import { InfoOutlined } from '@mui/icons-material';
import { FormWidgetI18nConfig, SimpleFormWidgetConfigProps, SimpleFormWidget } from '@procureai/ui-modules-mui';

import { I18nNamespace } from '~/common/types';
import {
  supplierContactSchemaWithName,
  SupplierContactWithName,
} from '~/routes/IntakeDetail/components/SupplierContactForm/SupplierContactForm.schema.ts';
import { SupplierContactForm } from '~/routes/IntakeDetail/components/SupplierContactForm/SupplierContactForm.tsx';

import { useSourcingCaseContactWidgetBackend } from './SourcingCaseContactWidget.hooks.tsx';

type FormSchema = SupplierContactWithName;

const config: SimpleFormWidgetConfigProps<FormSchema> = {
  schema: supplierContactSchemaWithName,
  defaultValues: {},
  iconComponent: InfoOutlined,
};
const i18n: FormWidgetI18nConfig = {
  ns: I18nNamespace.widgets,
  keyPrefix: 'SourcingCaseContactWidget',
};

export const SourcingCaseContactWidget = () => {
  return (
    <SimpleFormWidget<FormSchema> {...config} i18n={i18n} useBackend={useSourcingCaseContactWidgetBackend}>
      {(formProps) => <SupplierContactForm {...formProps} disableSupplierChange hideLocation />}
    </SimpleFormWidget>
  );
};
